import { render, staticRenderFns } from "./materialCustomer-add-or-update.vue?vue&type=template&id=093ddb70&scoped=true"
import script from "./materialCustomer-add-or-update.vue?vue&type=script&lang=js"
export * from "./materialCustomer-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./materialCustomer-add-or-update.vue?vue&type=style&index=0&id=093ddb70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093ddb70",
  null
  
)

export default component.exports